import ReactDOMServer from 'react-dom/server';
export const getUrl = (link) => {
  return `https://${process.env.REACT_APP_OCI_NAMESPACE}.objectstorage.${process.env.REACT_APP_OCI_REGION}.oci.customer-oci.com/n/axjkzbcsnn2z/b/${process.env.REACT_APP_OCI_BUCKET}/o/${link}`
}

export const truncateFileName = (name, length = 50) => {
  return name?.length <= length ? name : name.slice(0, (length - 4)) + '...  .' + name.split('.').pop()
}
export const sleep = ms => new Promise(r => setTimeout(r, ms));

export function getIconPath(component) {
  const iconString = ReactDOMServer.renderToString(component);
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(iconString, 'image/svg+xml');
  // console.log()
  // const iconPath = svgDoc.querySelector('path')?.getAttribute('d');
  return svgDoc.children[0].innerHTML;
}

export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = window.atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
